// extracted by mini-css-extract-plugin
export default {"button":"CreatePositionPopup_button__ucN2H","whiteContainer":"CreatePositionPopup_whiteContainer__c4PIt"};